import claimService from '@/services/claim.service'

const state = {
    logins: [],
    tours: [],
    hotels: [],
    chats: [],
    filters: [],
    claims: [],
    loading: false
}

const getters = {
    
}

const mutations = {
    setRead(state, messageId) {
        for (const claim of state.claims) {
            const message = claim.messages.find(msg => msg.id == messageId);
            if (message) {
                message.is_read = 1;
                return;
            }
        }
    },
    setLogins(state, logins = []) {
        state.logins = logins;
    },
    setTours(state, tours = []) {
        state.tours = tours;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setChats(state, chats = []) {
        state.chats = chats;
    },
    setFilters(state, filters = []) {
        state.filters = filters;
    },
    setClaims(state, claims = []) {
        state.claims = claims;
    },
    setLoadind(state, loading = false) {
        state.loading = loading;
    }
}

const actions = {
    clearResult ({ commit }) {
        commit('setClaims', []);
    },
    getLogins ({ commit }) {
        claimService.getLogins().then(response => {
            commit('setLogins', response);
        }).catch(() => {
        })
    },
    getTours ({ commit }) {
        claimService.getTours().then(response => {
            commit('setTours', response);
        }).catch(() => {
        })
    },
    getHotels ({ commit }) {
        claimService.getHotels().then(response => {
            commit('setHotels', response);
        }).catch(() => {
        })
    },
    getChats ({ commit }) {
        claimService.getChats().then(response => {
            commit('setChats', response);
        }).catch(() => {
        })
    },
    getFilters ({ commit }) {
        claimService.getFilters().then(response => {
            commit('setFilters', response);
        }).catch(() => {
        })
    },
    getClaims ({ commit }, params) {
        commit('setLoadind', true);
        claimService.getClaims(params).then(response => {
            commit('setClaims', response);
            commit('setLoadind', false);
        }).catch(() => {
            commit('setLoadind', false);
        })
    },
    setRead({ commit }, params) {
        return new Promise((resolve, reject) => {
            claimService.setRead(params)
                .then((response) => {
                    commit('setRead', params.chatId);
                    resolve(response);
                })
                .catch((error) => {
                    console.error('Error in setRead action:', error);
                    reject(error);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}